<section id="wire-transfer-section" class="section-card-content" data-cy="withdraw-wire-screen">
  <form>
    <p class="details tw-text-center tw-text-[15px] tw-text-[#0F2950] tw-mt-[95px] tw-mb-[15px]" data-cy="withdraw-wire-details">
      Please contact
      <a href="http://amwager.com/" class="amwager-email tw-text-[#3080EC]" data-cy="withdraw-wire-link">
        support&#64;amwager.com
      </a> to initiate a withdrawal via Bank Wire
    </p>

    <p class="notice tw-text-center text-font-bold tw-text-[15px] tw-text-[#0F2950] tw-mb-[90px]" data-cy="withdraw-wire-notice">
      A service charge of $25 will apply to wires requested under $5000.
    </p>
  </form>
</section>
